import flatPickr from 'vue-flatpickr-component'
import Vue from 'vue'

Vue.component('flat-pickr', flatPickr)